
let date = new Date();
let yyyy = date.getFullYear();
let hours = date.getHours();
let todayMS = date.getTime();

function dateFormatter(day, month, year = {yyyy}, returnAsDate = false) {
    let unformatted = new Date(year, (month - 1), day);
    let d = String(unformatted.getDate()).padStart(2, '0');
    let m = String(unformatted.getMonth() + 1).padStart(2, '0'); //January is 0!
    let y = unformatted.getFullYear();

    if( returnAsDate === true ) {
        return d + '/' + m + '/' + y;
    }

    return unformatted.getTime();
}

export const isHalloween = () => {
    let preHalloweenStart = dateFormatter(27,10,yyyy);
    let halloweenStart = dateFormatter(31,10,yyyy);
    let halloweenEnd = dateFormatter(2,11,yyyy);

    //Halloween all day
    if (todayMS >= halloweenStart && todayMS < halloweenEnd) {
      return true;
    }

    //Halloween evening
    if (todayMS >= preHalloweenStart && todayMS < halloweenEnd) {
      if( hours >= 17 || hours <= 7 ) {
        return true;
      }
    }

    return false;
}

export const isXmas = () => {
    let xmasStart = dateFormatter(1,12,yyyy);
    let xmasEnd = dateFormatter(5,1,(yyyy + 1));

    if (todayMS >= xmasStart && todayMS <= xmasEnd) { 
        return true;
    }

    return false;
}